// extracted by mini-css-extract-plugin
export default {"profile-relation":"Badge_profile-relation__DjA-3","beige":"Badge_beige__G4n0J","green":"Badge_green__TQFB1","blue":"Badge_blue__MBWlz","purple":"Badge_purple__CrWnw"};